<h1>{{ 'referentiels.list.uniteProperties.caption'| transloco }}</h1>

@if (userHasReadWritePermission) {
  <div class="flex justify-content-between flex-wrap my-1">
    <div class="flex gap-2">
      <div class="flex justify-content-start gap-2 mb-1">
        <p-button label="{{ 'button.add' | transloco }}" pRipple [rounded]="true" class="btn-light" icon="pi pi-plus" (click)="addNewUnite()" />
      </div>
    </div>
  </div>
}
<div class="card" [formGroup]="uniteForm">
  <p-table #unitsTable [(selection)]="selectedUnite" [value]="uniteFormArray.controls" styleClass="p-datatable-striped" selectionMode="single" editMode="row" dataKey="value.id">
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="userHasReadWritePermission" style="width: 5%"></th>
        <th pResizableColumn pSortableColumn="codeHecate" style="width: 20%">{{ 'referentiels.list.uniteProperties.codeHecate.header'| transloco }} <p-sortIcon field="codeHecate" /></th>
        <th pResizableColumn pSortableColumn="designation" style="width: 40%">{{ 'referentiels.list.uniteProperties.designation.header'| transloco }} <p-sortIcon field="designation" /></th>
        <th pResizableColumn pSortableColumn="codeCourt" style="width: 30%">{{ 'referentiels.list.uniteProperties.codeCourt.header'| transloco }} <p-sortIcon field="codeCourt" /></th>
      </tr>
      <tr>
        <th *ngIf="userHasReadWritePermission"></th>
        <th>
          <p-columnFilter type="text" field="value.codeHecate" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par Code Hecate" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="value.designation" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par  Désignation" [showMenu]="false" [showClearButton]="false" />
        </th>
        <th>
          <p-columnFilter type="text" field="value.codeCourt" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par Code court" [showMenu]="false" [showClearButton]="false" />
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-unite let-index="rowIndex" let-editing="editing">
      <ng-container>
        <tr [formGroup]="unite" [pEditableRow]="unite" [pSelectableRow]="unite">
          <td *ngIf="userHasReadWritePermission">
            <div class="flex align-items-center justify-content-center">
              <input id="uniteId-{{ index }}" pInputText type="hidden" formControlName="id" />
              <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" (click)="editUnite(unite)"></button>
              <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" size="small" class="p-button-sm" (click)="saveRowUnite(unite)"></button>
              <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" size="small" class="p-button-sm" (click)="cancelEditRowUnite(unite)"></button>
            </div>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeHecate-{{ index }}" pInputText type="text" formControlName="codeHecate" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ unite.value.codeHecate }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="designation-{{ index }}" pInputText type="text" formControlName="designation" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ unite.value.designation }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeCourt-{{ index }}" pInputText type="text" formControlName="codeCourt" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ unite.value.codeCourt }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>
<p-toast />
